module.exports = __webpack_public_path__ + "static/location-graphics-828db7fa083be1d3689fc8ea0935a8cb.gif";